const os = require('os'); // Importa el módulo 'os' de Node.js
const { Varios: {FechaHoraActual} } = require('neftis7_apicaller');

// Promisificar la función 'fs.appendFile' para que sea compatible con async/await
//const appendFileAsync = promisify(fs.appendFile);

export async function RespuestaCreacionExito(CodigoCompania, NombreFuncion, CodigoGenerado) {
    let respuesta;

    try {
        // Construir la respuesta de éxito
        respuesta = {
            operacion: "Creación",
            codigoGenerado: CodigoGenerado,
            mensaje: "Creación exitosa del Código " + CodigoGenerado + ".",
            mensajeCompleto: ""
        }

        console.log(FechaHoraActual() + "-" + CodigoCompania + "-" + "Solicitó con éxito " + NombreFuncion)
    } catch (error) {
        throw error;
    }

    return respuesta;
}

export async function RespuestaCreacionExitoDoble(CodigoCompania, NombreFuncion, CodigoGenerado1, CodigoGenerado2) {
    let respuesta;

    try {
        // Construir la respuesta de éxito
        respuesta = {
            operacion: "Creación",
            codigoGenerado1: CodigoGenerado1,
            codigoGenerado2: CodigoGenerado2,
            mensaje: "Creación exitosa del Código " + CodigoGenerado1 + " y el del Código " + CodigoGenerado2 + ".",
            mensajeCompleto: ""
        }

        console.log(FechaHoraActual() + "-" + CodigoCompania + "-" + "Solicitó con éxito " + NombreFuncion)
    } catch (error) {
        throw error;
    }

    return respuesta;
}

export async function RespuestaCreacionError(CodigoCompania, NombreFuncion, MensajeCompleto) {
    let respuesta;

    try {
        // Construir la respuesta de éxito
        respuesta = {
            operacion: "Creación",
            codigoGenerado: -1,
            mensaje: "ERROR en " + NombreFuncion,
            mensajeCompleto: "" + MensajeCompleto
        }

        console.log(FechaHoraActual() + "-" + CodigoCompania + "-Error en " + NombreFuncion + "-" + MensajeCompleto)
    } catch (error) {
        throw error;
    }

    return respuesta;
}

export async function RespuestaLecturaExito(CodigoCompania, NombreFuncion) {
    let respuesta;

    try {
        console.log(FechaHoraActual() + "-" + CodigoCompania + "-" + "Solicitó con éxito " + NombreFuncion)
    } catch (error) {
        throw error;
    }

    return respuesta;
}

export async function RespuestaLecturaExitoParaLeerVencimiento(CodigoCompania, NombreFuncion, CodigoCompaniaAVencer) {
    let respuesta;

    try {
        console.log(await FechaHoraActual() + "-" + CodigoCompania + "-" + "Solicitó con éxito " + NombreFuncion + " para la Empresa " + CodigoCompaniaAVencer)
    } catch (error) {
        throw error;
    }

    return respuesta;
}

export async function RespuestaLecturaError(CodigoCompania, NombreFuncion, MensajeCompleto) {
    let respuesta;

    try {
        // Construir la respuesta de éxito
        respuesta = {
            operacion: "Lectura",
            mensaje: "ERROR en " + NombreFuncion,
            mensajeCompleto: "" + MensajeCompleto
        }

        console.log(FechaHoraActual() + "-" + CodigoCompania + "-Error en " + NombreFuncion + "-" + MensajeCompleto)
    } catch (error) {
        throw error;
    }

    return respuesta;
}

export async function RespuestaLecturaLog(CodigoCompania, NombreFuncion, MensajeCompleto) {
    let respuesta;

    try {
        // Construir la respuesta de éxito
        respuesta = {
            operacion: "Lectura",
            mensaje: "LOG en " + NombreFuncion,
            mensajeCompleto: "" + MensajeCompleto
        }

        console.log(FechaHoraActual() + "-" + CodigoCompania + "-Log en " + NombreFuncion + "-" + MensajeCompleto)
    } catch (error) {
        throw error;
    }

    return respuesta;
}

export async function RespuestaModificacionExito(CodigoCompania, NombreFuncion, Codigo) {
    let respuesta;

    try {
        // Construir la respuesta de éxito
        respuesta = {
            operacion: "Modificación",
            mensaje: "Modificación exitosa del Código " + Codigo + ".",
            mensajeCompleto: ""
        }
        console.log(FechaHoraActual() + "-" + CodigoCompania + "-" + "Solicitó con éxito " + NombreFuncion)
    } catch (error) {
        throw error;
    }

    return respuesta;
}

export async function RespuestaModificacionError(CodigoCompania, NombreFuncion, MensajeCompleto) {
    let respuesta;

    try {
        // Construir la respuesta de éxito
        respuesta = {
            operacion: "Modificación",
            mensaje: "ERROR en " + NombreFuncion,
            mensajeCompleto: "" + MensajeCompleto
        }
        console.log(FechaHoraActual() + "-" + CodigoCompania + "-Error en " + NombreFuncion + "-" + MensajeCompleto)
    } catch (error) {
        throw error;
    }

    return respuesta;
}

export async function RespuestaEliminacionExito(CodigoCompania, NombreFuncion, Codigo) {
    let respuesta;

    try {
        // Construir la respuesta de éxito
        respuesta = {
            operacion: "Eliminación",
            mensaje: "Eliminación exitosa del Código " + Codigo + ".",
            mensajeCompleto: ""
        }

        console.log(FechaHoraActual() + "-" + CodigoCompania + "-" + "Solicitó con éxito " + NombreFuncion)
    } catch (error) {
        throw error;
    }

    return respuesta;
}

export async function RespuestaEliminacionError(CodigoCompania, NombreFuncion, MensajeCompleto) {
    let respuesta;

    try {
        // Construir la respuesta de éxito
        respuesta = {
            operacion: "Eliminación",
            mensaje: "ERROR en " + NombreFuncion,
            mensajeCompleto: "" + MensajeCompleto
        }

        console.log(FechaHoraActual() + "-" + CodigoCompania + "-Error en " + NombreFuncion + "-" + MensajeCompleto)
    } catch (error) {
        throw error;
    }

    return respuesta;
}